import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RoamingSearchCountryModalComponent } from '../roaming-search-country-modal/roaming-search-country-modal.component';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { SubjectService } from 'src/app/services/subject.service';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { RoamingSearchOptionsDataService } from 'src/app/services/roaming-search-options-data.service';

@Component({
  selector: 'app-roaming-search-options',
  templateUrl: './roaming-search-options.component.html',
  styleUrls: ['./roaming-search-options.component.scss'],
})
export class RoamingSearchOptionsComponent implements OnInit, AfterViewInit {
  @Input('ENV') ENV: string;
  @Input('popup') popup: boolean;
  @ViewChild('dropdownDiv') dropdownDiv!: ElementRef;
  lang: string;
  ismobileScreen: boolean;
  searchBar = '';
  constructor(
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private CDR: ChangeDetectorRef,
    public RSODS: RoamingSearchOptionsDataService
  ) {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    this.RSODS.setPopupOpened(false);
    this.RSODS.getRoamingCountriesList();
    this.SS.filterPopupOpenCountryList.subscribe((r) => {
      if (r == true) {
        this.RSODS.setShowCountryListOption(true);
        this.setPopupOpenned();
      } else if (r == false) {
        this.RSODS.setShowCountryListOption(false);
        this.CDR.detectChanges();
      }
    });

  }
  ngAfterViewInit() { }
  ngOnInit() {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    const w = document.documentElement.clientWidth || window.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
  }

  openCountryListOption() {
    try {
      if (this.ENV == 'mobile' || this.ismobileScreen == true) {
        this.openRoamingSearchCountryModalComponent();
        this.CDR.detectChanges();
      } else {
        if (this.searchBar && this.searchBar?.length > 0) {
          this.RSODS.setCountries([]);
          this.RSODS.setFrequentlyVisitedCountries([]);
          this.RSODS.groupCountries();
          this.searchBar = '';
          this.RSODS.selectedCountriesUpdateFlag();
          this.RSODS.configureFrequentlyVisited(
            this.RSODS.getOrignalCountryList()
          );
          this.RSODS.selectedFrequentCountriesUpdateFlag();
        }
        this.RSODS.setShowCountryListOption(
          !this.RSODS.getShowCountryListOption()
        );
      }
      this.CDR.detectChanges();
    } catch (e) {
      this.UTS.log(e);
    }
  }

  async openRoamingSearchCountryModalComponent() {
    if (this.getPopupOpenned() == true) {
      return false;
    }
    const modal = await this.modalController.create({
      component: RoamingSearchCountryModalComponent,
      showBackdrop: true,
      backdropDismiss: false,
      cssClass: 'ion-modal-uplift eand-partail-height-screen-bottom-mobile',
      componentProps: {
        data: { ENV: this.ENV, popup: true },
      },
    });
    this.SS.filterPopupOpenCountryList.next(true);

    modal.onDidDismiss().then((x: any) => {
      this.RSODS.setPopupOpened(false);
      this.RSODS.setShowCountryListOption(false);
      this.CDR.detectChanges();
    });
    return await modal.present();
  }

  async filterList(evt) {
    this.RSODS.filterList(evt);
    this.CDR.detectChanges();
  }

  closeAfterSelection() {
    if (this.ENV != 'mobile' && this.ismobileScreen != true) {
      this.RSODS.setShowCountryListOption(false);
      this.CDR.detectChanges();
    }
  }
  setPopupOpenned() {
    this.RSODS.setPopupOpened(true);
    this.modalController.dismiss();
  }
  getPopupOpenned() {
    if (this.RSODS.getPopupOpened() == true) return true;
    else return false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.dropdownDiv &&
      !this.dropdownDiv?.nativeElement?.contains(event.target) &&
      !(this.ENV == 'mobile' || this.ismobileScreen == true)
    ) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    if (this.ENV == 'mobile' || this.ismobileScreen == true) {
      this.RSODS.setShowCountryListOption(true);
      this.RSODS.setPopupOpened(true);
    } else {
      this.RSODS.setShowCountryListOption(false);
    }
    this.CDR.detectChanges();
  }
  changeSelection(e, id, C) {
    this.RSODS.selectCountryOption(id, C);
    this.closeAfterSelection();
  }

  async removeSelectedCountry(id, C) {
    try {
      this.RSODS.removeSelectedCountry(id, C);
      this.RSODS.selectedCountriesUpdateFlag();
      this.RSODS.selectedFrequentCountriesUpdateFlag();
      this.closeAfterSelection();
      if (this.ENV == 'mobile' || this.ismobileScreen == true) {
        this.modalController?.dismiss();
      }
    } catch (error) {
      console.log(error);
    }
  }
}
